export default __webpack_public_path__ + "static/media/zoom-demo.cb2c1b61.gif";